import React, { useMemo, useState } from 'react';

import { MattUtilitiesActions } from '../actions';
import moment from 'moment';
import 'moment/locale/es';
const MattUtilitiesContext = React.createContext();

const getMonths = () => {
  
  let months = []
  for (let i = 0; i < 12; i++) {
    const currentMonth = moment().subtract(i, 'month')
    months = [
      ...months,
      {
        name: currentMonth.format('MMMM'),
        startDate: currentMonth.startOf('month').format('YYYY-MM-DD'),
        endDate: currentMonth.endOf('month').format('YYYY-MM-DD'),
      },
    ];
  }
  return months;
}

const MattUtilitiesProvider = (props) => {
  const [monthsWithCutoffDates, setMonthsWithCutoffDates] = useState([]);
  const monthsWithoutCutoffDates = useMemo(() => getMonths(), [])

  const getMonthsWithCutoffDates = async () => {
    try {
      if (monthsWithCutoffDates.length === 0) {
        const monthsWithCutoffDates = await MattUtilitiesActions.onLoadMonthsWithCutDates();
        setMonthsWithCutoffDates(monthsWithCutoffDates);
      }
      return true;
    } catch(e) {
      return false;
    }
  }

  return (
    <MattUtilitiesContext.Provider
        value={{
          monthsWithCutoffDates,
          monthsWithoutCutoffDates,
          getMonthsWithCutoffDates
        }}
      >
        {props.children}
      </MattUtilitiesContext.Provider>
  )
}

export const Consumer = MattUtilitiesContext.Consumer;
export const Provider = MattUtilitiesProvider;
